var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showRagequitIcon)?_c('i',{staticClass:"ragequit-indicator fas fa-poo",attrs:{"title":_vm.ragequitTitle}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }